import {downloadAccountInfo} from 'src/openapi/admin/apis/AccountSearchDownloadRequestApi';
import {useAppDispatch} from 'src/store/hooks';

import {COLUMNS} from '../../../constants';

type Props = {
    data: Record<string, string>[],
    selectedColumns: string[],
    accountIds: number[],
    nameToIdsMap: Record<string, number>,
    apiDispatch: ReturnType<typeof useAppDispatch>,
};

export const fetchSsoData = async (props: Props): Promise<Record<string, string>[] | null> => {
    const {data, selectedColumns, accountIds, nameToIdsMap, apiDispatch} = props;

    const neededColumns = [COLUMNS.SSO_ENABLED, COLUMNS.SSO_MANDATORY].filter(
        col => selectedColumns.includes(col),
    );
    if (neededColumns.length === 0) {
        return data;
    }

    const response = await apiDispatch(downloadAccountInfo({entityDownloadInfoRequest: {ids: accountIds}}));
    if (!response.payload.success) {
        return null;
    }

    const ssoMap = new Map(response.payload.data.map(item => [item.id, item]));

    return data.map(row => {
        const accountId = nameToIdsMap[row[COLUMNS.ACCOUNT_NAME]];
        const sso = ssoMap.get(accountId);

        return {
            ...row,
            ...(selectedColumns.includes(COLUMNS.SSO_ENABLED) && {
                [COLUMNS.SSO_ENABLED]: sso?.ssoEnabled ? 'Yes' : 'No',
            }),
            ...(selectedColumns.includes(COLUMNS.SSO_MANDATORY) && {
                [COLUMNS.SSO_MANDATORY]: sso?.ssoMandatory ? 'Yes' : 'No',
            }),
        };
    });
};
